export default __webpack_public_path__ + "acd916299b7288433f5bace29147c233.png";